import { useRef } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { Reveal } from "@/components/Reveal";

const STEPS = [
  { n: "01", title: "Discover", text: "Understand the business, goals, customers and brand." },
  { n: "02", title: "Design", text: "Create the visual direction, layouts and user experience." },
  { n: "03", title: "Build", text: "Turn the design into a responsive working website." },
  { n: "04", title: "Launch", text: "Polish, test and launch the finished website." },
];

export const Process = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 75%", "end 55%"] });
  const lineScale = useSpring(scrollYProgress, { stiffness: 60, damping: 20 });

  return (
    <section data-testid="process-section" className="relative py-28 lg:py-40 px-5 sm:px-8 border-t border-white/5">
      <div className="max-w-7xl mx-auto">
        <Reveal className="mb-16 lg:mb-24">
          <p className="mono text-[11px] tracking-[0.28em] uppercase text-neutral-500 mb-5">The Process</p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-neutral-50">
            From idea to online.
          </h2>
        </Reveal>

        <div ref={ref} className="relative">
          <div className="hidden md:block absolute top-[7px] left-0 right-0 h-px bg-white/[0.07]" aria-hidden="true" />
          <motion.div
            className="hidden md:block absolute top-[7px] left-0 right-0 h-px bg-neutral-300 origin-left"
            style={{ scaleX: lineScale }}
            aria-hidden="true"
          />
          <div className="grid md:grid-cols-4 gap-12 md:gap-8">
            {STEPS.map((s, i) => (
              <Reveal key={s.n} delay={i * 0.12}>
                <div data-testid={`process-step-${s.n}`} className="relative">
                  <span className="hidden md:block w-[15px] h-[15px] rounded-full border border-white/25 bg-[#0a0a0b] relative z-10 mb-8" aria-hidden="true" />
                  <p className="mono text-xs text-neutral-600 tracking-[0.25em]">{s.n}</p>
                  <h3 className="font-display text-lg font-semibold uppercase tracking-[0.12em] text-neutral-100 mt-3">
                    {s.title}
                  </h3>
                  <p className="text-sm text-neutral-400 leading-relaxed mt-3 max-w-[240px]">{s.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
